
import React from 'react';
// FIX: Replaced ThumbsUpIcon with CheckCircleIcon as it's available in Icons.tsx.
import { XMarkIcon, SpinnerIcon, CheckCircleIcon, DocumentArrowDownIcon } from './Icons';
import { CIEN_CUADRAS_BUTTON_BLUE } from '../firebase/firebaseConfig';

interface ProcessingProgressModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  processedItems: number;
  totalItems: number;
  isComplete: boolean;
  errorMessage: string | null;
  results?: any[];
  onDownloadResults?: () => void;
  summaryMessage?: string | null;
}

export const ProcessingProgressModal: React.FC<ProcessingProgressModalProps> = ({
  isOpen,
  onClose,
  title,
  processedItems,
  totalItems,
  isComplete,
  errorMessage,
  results,
  onDownloadResults,
  summaryMessage,
}) => {
  if (!isOpen) return null;

  const progressPercentage = totalItems > 0 ? (processedItems / totalItems) * 100 : 0;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center p-4 z-50" role="dialog" aria-modal="true" aria-labelledby="processing-title">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 relative">
        <header className="mb-4">
          <h2 id="processing-title" className="text-xl font-semibold text-gray-800 text-center">
            {title}
          </h2>
        </header>

        <div className="my-6 text-center">
          {errorMessage ? (
            <div className="text-red-600">
              <p className="font-semibold">Error Durante el Procesamiento:</p>
              <p className="text-sm mt-1">{errorMessage}</p>
            </div>
          ) : isComplete ? (
            <div className="text-green-600 flex flex-col items-center">
              <CheckCircleIcon className="w-12 h-12 mb-2" />
              <p className="text-lg font-semibold">Proceso Completado</p>
              {summaryMessage ? (
                <p className="text-sm mt-2 text-gray-700 whitespace-pre-wrap">{summaryMessage}</p>
              ) : (
                <p className="text-sm">Se procesaron {processedItems} de {totalItems} registros.</p>
              )}
            </div>
          ) : (
            <>
              <SpinnerIcon className="w-12 h-12 text-sky-600 mx-auto mb-3" />
              <p className="text-gray-700 text-lg">
                Procesando registro {processedItems}/{totalItems}
              </p>
              {totalItems > 0 && (
                <div className="w-full bg-gray-200 rounded-full h-2.5 mt-3">
                  <div 
                    className="bg-sky-600 h-2.5 rounded-full transition-all duration-300 ease-out" 
                    style={{ width: `${progressPercentage}%` }}
                  ></div>
                </div>
              )}
            </>
          )}
        </div>

        <footer className="mt-6 flex flex-col sm:flex-row justify-center sm:space-x-3 space-y-2 sm:space-y-0">
          {(isComplete || errorMessage) && (
            <>
              <button
                onClick={onClose}
                className="w-full sm:w-auto px-6 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500"
                style={{ backgroundColor: CIEN_CUADRAS_BUTTON_BLUE }}
                aria-label={errorMessage ? "Cerrar modal de error" : "Aceptar y cerrar modal de progreso"}
              >
                {errorMessage ? 'Cerrar' : 'Aceptar'}
              </button>
              {isComplete && !errorMessage && onDownloadResults && results && results.length > 0 && (
                 <button
                  onClick={onDownloadResults}
                  className="w-full sm:w-auto px-4 py-2 flex items-center justify-center border text-sm font-medium rounded-md shadow-sm text-sky-700 bg-sky-100 hover:bg-sky-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500"
                >
                  <DocumentArrowDownIcon className="w-5 h-5 mr-2" />
                  Descargar Resultados
                </button>
              )}
            </>
          )}
        </footer>
      </div>
    </div>
  );
};